// Vendor imports
const Bluebird = require('bluebird')
const _ = require('lodash')

/**
 * Used by the `branch_params` field of `client_session` data
 * @returns {Object} Business Event Branch parameters
 * @see https://docs.branch.io/web/integrate/#initialize-branch-features
 * @see https://github.com/mix/mix/blob/master/app/views/partials/scripts/branch.pug
 */
function getBusinessEventParams() {
  return {
    ..._.get(window, 'branchInitData.data_parsed', {}),
    'branch_identity_id': (
      _.get(window, 'branchIdentity.identity_id') ||
      _.get(window, 'branchInitData.identity')
    )
  }
}

let initialized = false

async function initialize(user) {
  if (typeof window !== 'object' || !window.branch || window.branch._q) {
    return false // Branch SDK is not available
  }
  // eslint-disable-next-line no-undef -- Defined by Webpack DefinePlugin
  const { enabled, key } = branchConfig
  if (!enabled) {
    return false // Branch integration is disabled
  }
  if (initialized) {
    return true // Branch is already initialized
  }
  window.branchInitData = await Bluebird.fromCallback(callback => {
    window.branch.init(key, callback)
  })
  if (user.loggedIn) {
    window.branchIdentity = await Bluebird.fromCallback(callback => {
      window.branch.setIdentity(String(user.id), callback)
    })
  }
  initialized = true
  return true
}

async function sendSMS(phoneNumber, linkData, options = {}) {
  if (!initialized) {
    throw new Error('branch SDK is not initialized')
  }
  return Bluebird.fromCallback(callback => {
    window.branch.sendSMS(phoneNumber, linkData, options, callback)
  })
}

module.exports = {
  initialize,
  sendSMS,
  getBusinessEventParams
}
